export default "__VITE_ASSET__5WgzM2Vv__"